<template>
	<div class="text-center" style="border-radius: 10px; border:1px solid #dca6e5;">
		<div class="d-flex justify-center pa-3" v-if="!rangeMode">
			<v-btn @click="previousDay" small>
				<v-icon>mdi-chevron-right</v-icon>
				روز قبل
			</v-btn>
			<span class="px-2 text-h4 d-flex flex-column align-center justify-center secondary--text" style="width:145px">{{ currentDatePersian }}</span>
			<v-btn @click="nextDay" small>
				روز بعد
				<v-icon>mdi-chevron-left</v-icon>
			</v-btn>
		</div>
		<div class="d-flex justify-center pa-3" v-else>
			<div class="mx-2 d-flex">
				<span>از: </span>
				<date-picker v-model="dateRange.start" clearable format="YYYY-MM-DDTHH:mm:ss" auto-submit display-format="jYYYY/jMM/jDD" class="date-picker-input-sm mr-2" @change="emitValue" />
			</div>
			<div class="mx-2 d-flex">
				<span>تا: </span>
				<date-picker v-model="dateRange.end" clearable format="YYYY-MM-DDTHH:mm:ss" auto-submit display-format="jYYYY/jMM/jDD" class="date-picker-input-sm mr-2" @change="emitValue" />
			</div>
		</div>
		<div style="border-top: 1px dashed #ed7eff; border-bottom-left-radius: 10px;border-bottom-right-radius: 10px; background-color: #eaeaea;display: flex;padding:5px 10px;align-items: center;justify-content: center;">
			<v-btn plain color="secondary" small @click="rangeMode=!rangeMode">
				<span v-if="!rangeMode">انتخاب به صورت بازه ای</span>
				<span v-else>انتخاب به صورت ناوبری</span>
			</v-btn>
		</div>
	</div>
</template>

<script>
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

	export default {
		name: 'DateNavigator',
		components: {
			'date-picker': VuePersianDatetimePicker,
		},
		props: {
			options: {
				type: Object,
				default: () => { return { rangeMode: false, defaultEmpty: false } },
			},
			value: {
				type: Object
			}
		},
		data: () => ({
			currentDate: new Date(),
			dateRange: { start: new Date().toJSON(), end: new Date().toJSON() },
			rangeMode: false,
		}),
		created() {
			if (this.options.defaultEmpty) {
				this.dateRange.start = ''
				this.dateRange.end = ''
			} else {
				if (this.value?.start)
					this.dateRange.start = this.value.start
				if (this.value?.end)
					this.dateRange.end = this.value.end
			}
			this.emitValue()
			this.rangeMode = this.options.rangeMode
		},
		computed: {
			currentDatePersian() {
				if (!this.currentDate)
					return '-'
				return this.currentDate.toLocaleDateString('fa-IR')
			}
		},
		methods: {
			nextDay() {
				this.currentDate = new Date(this.currentDate.setDate(this.currentDate.getDate() + 1))
				this.dateRange.start = this.currentDate.toJSON()
				this.dateRange.end = this.currentDate.toJSON()
				this.emitValue()
			},
			previousDay() {
				this.currentDate = new Date(this.currentDate.setDate(this.currentDate.getDate() - 1))
				this.dateRange.start = this.currentDate.toJSON()
				this.dateRange.end = this.currentDate.toJSON()
				this.emitValue()
			},
			emitValue() {
				this.$emit('input', { ...this.dateRange })
				this.$emit('dateRangeChanged', this.dateRange.start, this.dateRange.end)
			}
		}
	}
</script>
